import React, { useId } from 'react'
import PropTypes from 'prop-types'

const ChevronRightIcon = React.forwardRef(function ChevronRightIcon(
  props,
  ref
) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path d="M9 20C8.77 20 8.54 19.92 8.35 19.76C7.93 19.4 7.88 18.77 8.24 18.35L13.68 12L8.24 5.65001C7.88 5.23001 7.93 4.60001 8.35 4.24001C8.77 3.88001 9.4 3.93001 9.76 4.35001L16.32 12L9.76 19.65C9.56 19.88 9.28 20 9 20Z"></path>
    </svg>
  )
})

ChevronRightIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

ChevronRightIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default ChevronRightIcon
